import React from 'react';

export function PageLoader() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-bg to-white-blue/30">
            <div className="flex flex-col items-center gap-8 p-8">
                {/* Breathing dots loader */}
                <div className="flex gap-2">
                    <div className="w-4 h-4 bg-primary rounded-full animate-pulse delay-0"></div>
                    <div className="w-4 h-4 bg-primary rounded-full animate-pulse delay-150"></div>
                    <div className="w-4 h-4 bg-primary rounded-full animate-pulse delay-300"></div>
                    <div className="w-4 h-4 bg-green rounded-full animate-pulse delay-500"></div>
                    <div className="w-4 h-4 bg-green rounded-full animate-pulse delay-700"></div>
                </div>
                
                {/* Animated loading text */}
                <div className="flex items-center gap-3">
                    <div className="text-xl font-semibold bg-gradient-to-r from-primary to-green bg-clip-text text-transparent">
                        Loading
                    </div>
                    <div className="flex gap-1">
                        <div className="w-1.5 h-1.5 bg-primary rounded-full animate-loading-dots"></div>
                        <div className="w-1.5 h-1.5 bg-primary rounded-full animate-loading-dots delay-150"></div>
                        <div className="w-1.5 h-1.5 bg-primary rounded-full animate-loading-dots delay-300"></div>
                    </div>
                </div>
                
                {/* Wave progress indicator */}
                <div className="w-64 h-2 bg-gray-200/50 rounded-full overflow-hidden">
                    <div className="h-full bg-gradient-to-r from-primary via-green to-primary animate-progress-flow rounded-full"></div>
                </div>
            </div>
        </div>
    );
} 